import { render, staticRenderFns } from "./NoBookingData.vue?vue&type=template&id=23ee1af2&scoped=true&"
import script from "./NoBookingData.vue?vue&type=script&lang=js&"
export * from "./NoBookingData.vue?vue&type=script&lang=js&"
import style0 from "./NoBookingData.vue?vue&type=style&index=0&id=23ee1af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee1af2",
  null
  
)

export default component.exports